export * from './reset-password-result.component';
